module.exports = __webpack_public_path__ + "static/media/Rectangle 2.b4da9e2c.png";